const __request = require(`./__request/__request_contentType_json`);

// 编辑广告的上/下架状态：http://tour-beta.yinzhilv.com/doc.html#/yinzhilv_travel/advert-controller/updateAdvertStateByIdUsingPOST
const web_common_advert_updateAdvertStateById = (pParameter) => {
    if (!pParameter) pParameter = {};
    const p = {
        method: 'post',
        urlSuffix: '/web/common/advert/updateAdvertStateById',
        data: pParameter
    };
    return new Promise(function(resolve, reject) {
        resolve(__request(p))
    })
};
module.exports = web_common_advert_updateAdvertStateById;